import styled from 'styled-components';

import { useStateContext } from '../../context';
import { calcDistanceKm } from '../../utils';
import { StoreCard } from '../StoreCard';
import { colors } from '../../constants';

interface IProps {
    className?: string;
}

const BaseInfoWindow = ({ className }: IProps) => {
    const { searchLocation, selectedStore, storesSortedByDistance } =
        useStateContext();

    if (!selectedStore || !storesSortedByDistance) return null;

    if (searchLocation) {
        selectedStore.distanceKm = calcDistanceKm(
            {
                lat: selectedStore.lat,
                lng: selectedStore.lng,
            },
            searchLocation
        );
    }

    const storeSearchPosition = storesSortedByDistance?.findIndex(
        (store) => store.id === selectedStore.id
    );

    return (
        <div className={className}>
            <StoreCard
                hideDistance
                hideOpeningHours
                store={selectedStore}
                searchPosition={storeSearchPosition + 1}
                isInfoWindow
            />
        </div>
    );
};

export const InfoWindow = styled(BaseInfoWindow)`
    ${StoreCard} {
        background-color: ${colors.white};
        margin: 0;
        padding: 20px;
        border: none;
        min-width: 360px;

        &:hover {
            border: none;
        }
    }
`;
